import { Button, CloseIcon, Modal } from '@bp/ui-components';
import dayjs from 'dayjs';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTeachingBlockStore } from '../../Contexts/TeachingBlockContext';
import { CardDurationForm } from '../../Forms/CardDurationForm/CardDurationForm';
import { TeachingBlockCard } from '../../TeachingBlockCard/TeachingBlockCard';
import styles from './CardDurationModal.module.scss';

export const CardDurationModal = observer(() => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  const store = useTeachingBlockStore();

  // Get missing variables from store
  const previousCard = store.cardDurationModal.previousCard;
  const previousHoliday = store.cardDurationModal.previousHoliday;
  const nextCard = store.cardDurationModal.nextCard;
  const nextHoliday = store.cardDurationModal.nextHoliday;
  const isVirtual = store.cardDurationModal.isVirtual;
  const isOpen = store.cardDurationModal.isOpen;
  const card = store.cardDurationModal.card;

  const Header = (
    <div className={styles['custom-header']}>
      <div className={styles.headline}>{t('pinboard.actions.editTime')}</div>
      {card && <TeachingBlockCard card={card} passive />}
      <Button className={styles.close} icon={<CloseIcon />} hierarchy='tertiary' onClick={onClose} />
    </div>
  );

  const previous =
    previousCard && previousHoliday
      ? dayjs(previousCard?.endDate).isAfter(previousHoliday?.end, 'day')
        ? previousCard
        : previousHoliday
      : previousCard
        ? previousCard
        : (previousHoliday ?? null);

  const next =
    nextCard && nextHoliday
      ? dayjs(nextCard?.startDate).isBefore(nextHoliday?.start, 'day')
        ? nextCard
        : nextHoliday
      : nextCard
        ? nextCard
        : (nextHoliday ?? null);

  function onClose() {
    store.setCardDurationModal({ isOpen: false });
  }

  return (
    <Modal
      parent={document.fullscreenElement ? document.getElementById('teaching-block-grid') : null}
      isOpen={isOpen ?? false}
      onRequestClose={onClose}
      loading={loading}
      customHeader={Header}
      className={styles['card-edit-modal']}
    >
      {card && (
        <CardDurationForm
          card={card}
          isVirtual={isVirtual ?? false}
          previous={previous}
          next={next}
          onLoad={setLoading}
          onClose={onClose}
        />
      )}
    </Modal>
  );
});
